import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { RootState } from "../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import "react-tabs/style/react-tabs.css";
import SummaryTab from "./ZalesTabs/ZalesSummaryTab"
import ProductTab from "./ZalesTabs/ZalesProductTab";
import ByStoreTab from "./ZalesTabs/ZalesByStore";
import SinageTab from "./ZalesTabs/ZalesSignageView"
import useClasses from "../../common/UseClasses";

  const useStyles = () => ({
    root: {
      width: "100%",
    },
    container: {
      maxHeight: 440,
    },
  });


type PropsFromRedux = ConnectedProps<typeof connector>;
type ZalesMainProps = PropsFromRedux & {};
const ZalesMainScreen: React.FC<ZalesMainProps> = ({ ...rest }) => {
    
  // const classes = useStyles();
  const classes: any = useClasses(useStyles);

    return (
        <div
        style={{
          display: "flex",
          flex: 1,
          padding: 16,
          flexDirection: "column",
        }}
      >

      <Tabs>
        <TabList>
          <Tab>Summary</Tab>
          <Tab>By Store</Tab>
          <Tab>Product Data</Tab>
          <Tab>Signage View</Tab>
        </TabList>
        <TabPanel>
            <SummaryTab />
        </TabPanel>
        <TabPanel>
            <ByStoreTab />
        </TabPanel>
        <TabPanel>
          <ProductTab/>
        </TabPanel>
        <TabPanel>
          <SinageTab/>
        </TabPanel>
    </Tabs>
    </div>
    );
};

const mapState = (state: RootState) => ({});

const mapDispatch = {};

const connector = connect(mapState, {

});

export default connector(ZalesMainScreen);
